import React from "react";
import SelectBox, { SelectBoxProps } from "./SelectBox";
import { useCountriesData } from "../../services/public.services";
import { useFormContext } from "react-hook-form";

interface CitySelectInputProps extends Omit<SelectBoxProps, "options"> {
  countryFieldName?: string;
  stateFieldName?: string;
}

const DependentSelectCityInput: React.FC<CitySelectInputProps> = ({ countryFieldName, stateFieldName, ...selectBoxProps }) => {
  const { data, isLoading, error } = useCountriesData();
  const { getValues } = useFormContext();
  let cityOptions: { label: string; value: string }[] = [];

  const countryName = countryFieldName ? getValues(countryFieldName) : undefined;
  const stateName = stateFieldName ? getValues(stateFieldName) : undefined;

  if (countryName && stateName && data && Array.isArray(data.Countries)) {
    const country = data.Countries.find((country: any) => country.CountryName.toLowerCase() === countryName.toLowerCase());
    if (country && Array.isArray(country.States)) {
      const state = country.States.find((state: any) => state.StateName.toLowerCase() === stateName.toLowerCase());
      if (state && Array.isArray(state.Cities)) {
        cityOptions = state.Cities.map((city: any) => ({
          label: city,
          value: city,
        }));
      }
    }
  }

  return (
    <SelectBox
      options={cityOptions}
      loading={isLoading}
      errorText={error ? "Failed to load cities options" : ""}
      {...selectBoxProps}
      showSearch
      disabled={!countryName || !stateName || selectBoxProps.disabled}
    />
  );
};

export default DependentSelectCityInput;
